// Single source of truth for the password-strength policy. Imported
// by the frontend (RegisterPage, ResetPasswordPage, DirectorInvite-
// AcceptPage) and the backend (invite + director-invite DTOs +
// services) so client and server always agree.
//
// Story 075 reverted to the pre-audit policy of 8-char minimum with
// no complexity rule. This is a tournament system — each user only
// manages their own player data, so the burden of password strength
// stays with the user, not the system. HIBP breach checking (once
// Supabase Pro is enabled) is the real defense against credential
// stuffing; we don't need to second-guess the user's choice beyond
// that.
export const PASSWORD_MIN_LENGTH = 8;
export function isPasswordValid(password) {
    return password.length >= PASSWORD_MIN_LENGTH;
}
//# sourceMappingURL=password-policy.js.map